// Mirrors Volt2-API enums; the API serializes them as numbers.
export const BcAttemptState = {
  Undefined: 0,
  CnpNotFound: 1,
  NeedPhoneVerification: 2,
  NoPhoneRegistered: 3,
  Completed: 4,
} as const;

export type BcAttemptState =
  (typeof BcAttemptState)[keyof typeof BcAttemptState];

export const PhoneVerificationError = {
  None: 0,
  InvalidCode: 1,
  LimitExceeded: 2,
  Unexpected: 3,
} as const;

export type PhoneVerificationError =
  (typeof PhoneVerificationError)[keyof typeof PhoneVerificationError];

export interface ScoringInterrogationAttempt {
  bcAttemptState: BcAttemptState;
  phoneVerificationError: PhoneVerificationError;
  kycRequired: boolean;
  termsRequired: boolean;
  ficoScore: number | null;
}

// Wrong or expired codes and failed SMS sends come back as HTTP 200 with
// `phoneVerificationError` set, not as errors.
export interface BcAttempt {
  bcAttemptState: BcAttemptState;
  phoneVerificationError: PhoneVerificationError;
}

export interface BcPhoneNumber {
  id: string;
  phone: string;
}

export interface ScoringState {
  interrogationEnabled: boolean;
  interrogationDate: string | null;
  // -1 when the CNP has no history at the credit bureau
  ficoScore: number | null;
  isFirstScore: boolean;
  bcAttemptState: BcAttemptState;
  isFicoAngroActive: boolean;
  isOutDated: boolean;
}

export const ScoringErrorCode = {
  TermsNotAccepted: 'terms_not_accepted',
  AlreadyHasScore: 'already_has_score_by_code',
} as const;
